// extracted by mini-css-extract-plugin
export default {"content":"sBI0CHjkdGjE5sgSXI3S","preview":"b94EKI9g02yhJsJudEAP"};